<script lang="ts">
	let {
		name,
		size = 24,
		class: className = '',
		strokeWidth = 2
	}: {
		name: string;
		size?: number;
		class?: string;
		strokeWidth?: number;
	} = $props();

	// Map icon names to their SVG content
	const iconMap: Record<string, string> = {
		plus: '<path d="M5 12h14m-7-7v14"/>',
		pencil: '<path d="M12 20h9M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>',
		trash:
			'<path d="M3 6h18m-2 0v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6m3 0V4c0-1 1-2 2-2h4c0-1 1-2 2-2v2m-6 5v6m4-6v6"/>',
		users:
			'<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 7a4 4 0 1 0 8 0 4 4 0 0 0-8 0M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>',
		x: '<path d="M18 6 6 18M6 6l12 12"/>',
		eye: '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>',
		tag: '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/>',
		hash: '<line x1="4" y1="9" x2="20" y2="9"/><line x1="4" y1="15" x2="20" y2="15"/><line x1="10" y1="3" x2="8" y2="21"/><line x1="16" y1="3" x2="14" y2="21"/>',
		anchor:
			'<circle cx="12" cy="5" r="3"/><line x1="12" y1="22" x2="12" y2="8"/><path d="M5 12H2a10 10 0 0 0 20 0h-3"/>'
	};

	const iconPath = iconMap[name];

	if (!iconPath) {
		console.warn(`Icon "${name}" not found in icon map`);
	}
</script>

{#if iconPath}
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		stroke-width={strokeWidth}
		stroke-linecap="round"
		stroke-linejoin="round"
		class="inline-flex items-center justify-center {className}"
	>
		<!-- eslint-disable-next-line svelte/no-at-html-tags -->
		{@html iconPath}
	</svg>
{:else}
	<span
		class="inline-flex items-center justify-center {className}"
		style="width: {size}px; height: {size}px;"
	></span>
{/if}
